import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/pro-light-svg-icons'

interface FoldableComponentProps {
	title: string
	children: React.ElementRef<any> | React.ElementRef<any>[]
	headerComp?: React.ElementRef<any> | React.ElementRef<any>[]
	initialOpen?: boolean
	className?: string
}

const FoldableComponent: React.FunctionComponent<FoldableComponentProps> = ({
	title,
	children,
	headerComp,
	initialOpen,
	className = '',
}: FoldableComponentProps) => {
	const [open, setOpen] = useState(initialOpen || false)
	const [mounted, setMounted] = useState(false)

	useEffect(() => {
		if (!mounted && open) {
			setMounted(true)
		}
	}, [open])

	return (
		<div className={className}>
			{/* Head */}
			<div
				className={`flex flex-row items-center text-md px-4 py-2 pl-4 border rounded-md ${
					open ? 'rounded-bl-none rounded-br-none' : ''
				} cursor-pointer bg-white`}
				onClick={() => setOpen((prev) => !prev)}
			>
				<FontAwesomeIcon
					className={open ? 'fa-flip-vertical' : ''}
					icon={faAngleDown}
				/>
				<h1 className="ml-2">{title}</h1>

				{/* Header component slot */}
				{headerComp ? <div className="ml-auto">{headerComp}</div> : null}
			</div>
			{/* Body */}
			<div
				className={`flex flex-col border border-t-0 rounded-bl-md rounded-br-md ${
					open ? 'rounded-bl-md rounded-br-md' : ''
				} ${open ? 'visible' : 'hidden'}`}
			>
				{open || mounted ? children : null}
			</div>
		</div>
	)
}

export default FoldableComponent
